import React from 'react';

const ChatIcon: React.FC<{ className?: string }> = ({ className }) => {
  return (
   <svg
  xmlns="http://www.w3.org/2000/svg"
  version="1.1"
  viewBox="0 0 160 160"
  className={className}
  width="1em"
  height="1em"
>
  <g>
    <path
      d="M16.83,146.17c-1.62-.02-2.91-1.33-2.92-2.95-.26-27.94-.16-55.25-.07-70.03.05-8.33,2.23-16.49,6.34-23.73C30.69,30.96,49.85,12.44,85.29,13.8c35.74,1.38,59.96,18.4,62.88,54.91,1.06,13.24.63,31.1-2.89,40.52-5.7,15.28-18.68,37.04-56.46,36.53-16.93-.23-46.78.69-71.99.41Z"
      fill="white"
      stroke="currentColor"
      strokeWidth="11"
      strokeMiterlimit="10"
    />
    <path
      d="M46.75,72.16c16.69.16,61.03-.24,69.74,0"
      fill="none"
      stroke="currentColor"
      strokeWidth="11"
      strokeLinecap="round"
      strokeMiterlimit="10"
    />
    <path
      d="M46.75,105.16c9.54.09,24.36-.19,29.53-.04"
      fill="none"
      stroke="currentColor"
      strokeWidth="11"
      strokeLinecap="round"
      strokeMiterlimit="10"
    />
  </g>
</svg>

  );
};

export default ChatIcon;
